import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Box } from "@nubeteck/components";
import { Header, MobileMenu } from "../../layout";
import { MainContainer } from "./main-layout.styled";
import { useGetUserInfoQuery } from "src/services";
import { useDispatch } from "react-redux";
import { AppDispatch } from "src/core/store/store";
import { setUserInfo } from "src/core/store/slices/userSlice";
import { getRolesByToken } from "src/utils";

interface IMenuItem {
  name: string;
  link: string;
  icon: string;
  roles?: string[];
  exactLink?: string;
}

const MainLayout = () => {
  const [isMenuMobileVisible, setMenuMobileVisible] = React.useState(false);
  const { data: userInfo } = useGetUserInfoQuery("", {
    refetchOnMountOrArgChange: true,
  });
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const roles = getRolesByToken(localStorage.getItem("token") ?? "");
  const isAdmin = roles.find((r) => r !== "estudiante");

  const menuItems: IMenuItem[] = [
    { name: "Inicio", link: "/", icon: "" },
    { name: "Materias", link: "/subjects-list", icon: "" },
    {
      name: "Matrícula",
      link: "/subjects-registration/initial",
      icon: "",
      exactLink: "subjects-registration",
    },
    { name: "Caja", link: "/cart/general", icon: "", exactLink: "cart" },
    { name: "Calendario", link: "/calendar", icon: "" },
    { name: "Solicitudes", link: "/requests", icon: "" },
    { name: "Reportes", link: "/reports", icon: "" },
  ];

  const adminMenuItems: IMenuItem[] = [
    {
      name: "Inicio",
      link: "/",
      icon: "",
      roles: ["cajero", "administrador(a) del sistema", "perfil financiero", "vicerrectoria"],
    },
    { name: "Patrocinios", link: "/admin/sponsorships", icon: "", roles: ["perfil financiero"] },
    { name: "Transferencias", link: "/admin/reviews", icon: "", roles: ["perfil financiero"] },
    { name: "Importaciones", link: "/admin/data-imports", icon: "", roles: ["vicerrectoria"] },
    {
      name: "Solicitudes",
      link: "/admin/requests",
      icon: "",
      roles: ["administrador(a) del sistema"],
    },
    {
      name: "Caja",
      link: "/admin/charges",
      icon: "",
      roles: ["cajero"],
    },
    {
      name: "Configuraciones",
      link: "/admin/settings",
      icon: "",
      roles: ["administrador(a) del sistema"],
    },
  ];
  useEffect(() => {
    if (userInfo?.data) {
      dispatch(setUserInfo(userInfo?.data));
    }
  }, [userInfo, dispatch]);

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/login");
    }
  }, [navigate]);

  const getMenuByAdminRoles = (menuItems: IMenuItem[]) => {
    const result = menuItems.filter((menu) => menu.roles?.find((rol) => roles.includes(rol)));
    return result;
  };

  return (
    <Box>
      <MobileMenu
        menuItems={isAdmin ? getMenuByAdminRoles(adminMenuItems) : menuItems}
        userName={userInfo?.data?.fullName}
        isHelpVisible={!isAdmin}
        isVisible={isMenuMobileVisible}
        hide={() => {
          setMenuMobileVisible(false);
        }}
      />
      <Header
        menuItems={isAdmin ? getMenuByAdminRoles(adminMenuItems) : menuItems}
        userName={userInfo?.data?.fullName}
        isHelpVisible={!isAdmin}
        openMenu={() => {
          setMenuMobileVisible(true);
        }}
      />
      <MainContainer>
        <Outlet />
      </MainContainer>
    </Box>
  );
};

export default MainLayout;
